import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", color: "white", textAlign: "center", backgroundImage: "url('/background.png')", backgroundSize: "cover" }}>
      <Helmet><title>404 - Lost | UN-LOCKED</title></Helmet>
      <h1 style={{ color: "gold", fontSize: "6em", margin: 0, textShadow: "0 0 20px rgba(255,215,0,0.5)" }}>404</h1>
      <h2 style={{ fontSize: "2em" }}>You got lost in the Decks!</h2>
      <p style={{ color: "#aaa", fontSize: "1.2em", marginBottom: "30px" }}>This Site does not exist.</p>
      <button onClick={() => navigate("/")} style={{ padding: "15px 30px", fontSize: "1.2em", backgroundColor: "gold", color: "black", border: "none", borderRadius: "10px", cursor: "pointer", fontWeight: "bold" }}>
        Back to the Lobby
      </button>
    </div>
  );
}